<div class="background" [ngStyle]="backgroundStyle"></div>
